import { IInputStyle } from '@components/Input/max/interface'
import styled, { css } from 'styled-components'

export const Wrapper = styled.div`
  position: relative;
`

export const StyledInput = styled.input<IInputStyle>`
  ${({ disabled, ghost, button, theme: { input }, light }) => css`
    /* Default */
    background-color: ${input.backgroundColor};
    border-radius: ${input.borderRadius};
    border: ${light ? 'none' : input.border};
    color: ${input.textColor};
    display: block;
    font-size: ${input.fontSize};
    line-height: ${input.lineHeight};
    padding: ${input.padding};
    width: 100%;

    &::placeholder {
      color: ${input.placeholderColor};
    }

    ${
      disabled &&
      css`
        cursor: not-allowed;
        color: ${input.textColorDisabled};
        background-color: ${input.backgroundColorDisabled};
      `
    };
    }
    
    ${
      ghost &&
      css`
        border: 0;
        border-radius: 0;
        background-color: transparent;
        border-bottom: ${input.borderBottomGhost};
      `
    };

    /* With button to the right */
    ${
      button &&
      css`
        padding-right: ${input.buttonWidth};
      `
    };
  `};
`

export const SubmitButton = styled.button`
  cursor: pointer;
  display: flex;
  height: 100%;
  justify-content: center;
  padding: 0;
  position: absolute;
  right: 0;
  top: 0;
  width: ${({ theme }) => theme.input.buttonWidth};
`

export const IconWrapper = styled.span`
  right: ${({ theme }) => theme.space.sm};
  position: absolute;
  top: 50%;
  z-index: 2;
  line-height: 0;
  transform: translateY(-50%);
`
